import styled from 'styled-components';

export const HStack = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
